import Decimal from 'decimal.js';

import EntityStore from 'stores/EntityStore';

import {UnitTypesQuery} from './__generated/UnitTypesQuery';

export function isUnitDictionaryManagementEnabledForUser(): boolean {
  const currentUser = EntityStore.currentUser();
  return currentUser?.isTenantAdmin;
}

type GqlUnitType = UnitTypesQuery['unitTypes'][number];
type GqlUnit = UnitTypesQuery['unitTypes'][number]['baseUnit'];

export type HydratedUnit = Omit<GqlUnit, 'conversionFactor'> & {
  unitType: GqlUnitType;
  conversionFactor: Decimal;
};

export function hydrateGqlUnit(unit: GqlUnit, unitType: GqlUnitType): HydratedUnit {
  return {...unit, unitType, conversionFactor: new Decimal(unit.conversionFactor)};
}
